import ApiResponse from "src/interfaces/ApiResponse";
import {
  ConfiguracaoPayload,
  ConfiguracoesFiltrarParams,
} from "src/pages/Privada/Configuracoes/Sistema/Cadastro/SistemaCadastro.Dto";
import { SistemaFiltrarDto } from "src/pages/Privada/Configuracoes/Sistema/Sistema.Dto";
import { NFCeConsultaInputDto } from "src/pages/Privada/Fiscal/NFCe/Consulta/NFCe.Consulta.Dto";
import { NFCeDto } from "src/pages/Privada/Fiscal/NFCe/NFCe.Dto";
import { TributacaoCfopCadastroDto } from "src/pages/Privada/Fiscal/Tributacao/Cfop/Cadastro/TributacaoCfopCadastro.Dto";
import { TributacaoCfopImpostoCadastroDto } from "src/pages/Privada/Fiscal/Tributacao/Imposto/Cadastro/TributacaoCfopImpostoCadastro.Dto";
import { TributacaoCadastroDto } from "src/pages/Privada/Fiscal/Tributacao/Tributacao/Cadastro/TributacaoCadastro.Dto";
import { TributacaoFiltrarDto } from "src/pages/Privada/Fiscal/Tributacao/Tributacao/Tributacao.Dto";
import api from "./api";

export function TributacaoFiltrar(input: TributacaoFiltrarDto) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/filtrar",
    {
      params: input,
    }
  );
}

export function TributacaoBuscarPorId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/tributacao/buscar-por-id?id=" +
      id
  );
}

export function TributacaoIncluir(input: TributacaoCadastroDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/incluir",
    input
  );
}

export function TributacaoAtualizar(input: TributacaoCadastroDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/atualizar",
    input
  );
}

export function TributacaoCfopBuscarPorTributacaoId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/tributacao/cfop/buscar-por-tributacao-id?tributacaoId=" +
      id
  );
}

export function TributacaoCfopBuscarId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/tributacao/cfop/buscar-por-id?id=" +
      id
  );
}

export function TributacaoCfopIncluir(input: TributacaoCfopCadastroDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/cfop/incluir",
    input
  );
}

export function TributacaoCfopAtualizar(input: TributacaoCfopCadastroDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/cfop/atualizar",
    input
  );
}

export function TributacaoCfopImpostoBuscarId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/tributacao/imposto/buscar-por-id?id=" +
      id
  );
}

export function TributacaoCfopImpostoIncluir(
  input: TributacaoCfopImpostoCadastroDto
) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/imposto/incluir",
    input
  );
}

export function TributacaoCfopImpostoAlterar(
  input: TributacaoCfopImpostoCadastroDto
) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/imposto/atualizar",
    input
  );
}

export function NFCeIncluir(input: NFCeDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/incluir",
    input
  );
}

export function NFCeEnviar(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/enviar?id=" + id
  );
}

export function NFCeImprimir(id: number) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/imprimir/danfe?id=" + id,
    {
      responseType: "blob",
    }
  );
}

export function NFCeBuscarUltima(serie: number) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/nfce/buscar-ultima?serie=" +
      serie
  );
}

export function NFCeFiltrar(input: NFCeConsultaInputDto) {
  const params: any = {};

  if (input.codigoStatusEnvio) {
    params.codigoStatusEnvio = input.codigoStatusEnvio;
  }

  if (input.dataEmissaoInicial) {
    params.dataEmissaoInicial = input.dataEmissaoInicial
      .toISOString()
      .slice(0, 10);
  }

  if (input.dataEmissaoFinal) {
    params.dataEmissaoFinal = input.dataEmissaoFinal.toISOString().slice(0, 10);
  }

  if (input.serie) {
    params.serie = input.serie;
  }

  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/filtrar",
    {
      params,
    }
  );
}

export function NFCeExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/excluir?id=" + id
  );
}

export function ConfiguracaoFiltrar(params: SistemaFiltrarDto) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/configuracao/filtrar",
    {
      params,
    }
  );
}

export function NFCeBuscarXML(ids: number[], nomeArquivo: string) {
  const params = new URLSearchParams();

  ids.forEach((id) => params.append("ids", id.toString()));
  params.append("nomeArquivo", encodeURIComponent(nomeArquivo));

  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/nfce/buscar-xml?" +
      params.toString(),
    {
      responseType: "blob",
    }
  );
}

export function CategoriaBuscarPorId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/categoria/buscar-por-id?id=" +
      id
  );
}

export function ConfiguracaoIncluir(payload: ConfiguracaoPayload) {
  return api.post(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/configuracao/incluir",
    payload
  );
}

export function ConfiguracaoAtualizar(payload: ConfiguracaoPayload) {
  return api.put(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/configuracao/atualizar",
    payload
  );
}

export function ConfiguracoesFiltrar(params: ConfiguracoesFiltrarParams) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/configuracao/filtrar",
    {
      params,
    }
  );
}

export function NFCeConsultarSituacao(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/nfce/consultar-situacao?id=" +
      id
  );
}
